import { BrowserRouter, Route, Routes } from "react-router";
import MainLayout from "../components/layouts/MainLayout";
import HomePage from "../features/portfolio/home/HomePage";
import DashboardLayout from "../components/layouts/DashboardLayout";
import NewsPage from "../features/portfolio/news/NewsPage";
import ReferencesPage from "../features/portfolio/references/ReferencesPage";
import ServicesPage from "../features/portfolio/services/ServicesPage";
import PartnersPage from "../features/portfolio/partners/PartnersPage";
import AboutPage from "../features/portfolio/about/AboutPage";
import ProductsPage from "../features/portfolio/products/ProductsPage";
import ContactUsPage from "../features/portfolio/contact/ContactUsPage";
import ProtectedRoute from "./ProtectedRoute";
import LoginPage from "../features/auth/LoginPage";
import ManageNews from "../features/dashboard/manageNews/ManageNews";
import ManageReferences from "../features/dashboard/manageReferences/ManageReferences";
import ManageServices from "../features/dashboard/manageServices/ManageServices";
import ManagePartners from "../features/dashboard/managePartners/ManagePartners";
import ManageProducts from "../features/dashboard/manageProducts/ManageProducts";

function RoutesList() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Portfolio pages */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />}></Route>
          <Route path="news" element={<NewsPage />}></Route>
          <Route path="reference" element={<ReferencesPage />}></Route>
          <Route path="services" element={<ServicesPage />}></Route>
          <Route path="partners" element={<PartnersPage />}></Route>
          <Route path="about" element={<AboutPage />}></Route>
          <Route path="products" element={<ProductsPage />}></Route>
          <Route path="contact" element={<ContactUsPage />}></Route>
        </Route>

        {/* Login page */}
        <Route path="/login" element={<LoginPage />} />

        {/* Dashboard pages */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="news" element={<ManageNews />} />
          <Route path="references" element={<ManageReferences />} />
          <Route path="services" element={<ManageServices />} />
          <Route path="partners" element={<ManagePartners />} />
          <Route path="products" element={<ManageProducts />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default RoutesList;
